import type React from "react";
import CheckIcon from "~/images/check.svg?react";
import styles from "./index.module.scss";

interface PlanListProps {
  text: string; // ボタンのラベル
}

const PlanListItem: React.FC<PlanListProps> = ({ text }) => {
  return (
    <div className={styles["planListItemContainer"]}>
      <CheckIcon />
      <p>{text}</p>
    </div>
  );
};

export default PlanListItem;
